import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import moment from "moment";
import { ErrorMessage } from "formik";
import { Box, Grid } from "@mui/material";

import Field from "../../component/Field";
import Label from "../../component/Label";
import Toaster from "../../component/Toaster";
import SelectField from "../../component/SelectField";
import SimpleDate from "../../component/simpleDate";
import EditableSelectField from "../../component/editableSelectField";
import { CommonUtil, LocalStorage, LoginUserDetails } from "../../util/Utils";

import { useAppDispatch } from "../../store/hooks";
import { CommonService } from "../../store/common/CommonSlice";
import { itemMasterService } from "../../store/itemMaster/itemMasterSlice";
import { studentMasterService } from "../../store/studentMaster/StudentMasterSlice";
import GlobalLoader from "../../component/GlobalLoader";
import { AddCircle } from "@mui/icons-material/";
import AddCi from "./AddCi";
import { courseInstructorAction } from "../../store/courseInstructor/courseInstructorSlice";
import dayjs from "dayjs";
import { countryWiseDateFormate, DateTimeUtil } from "../../util/DateTimeUtils";

interface CourseBatchInfoProps {
  handleDrawerClose?: any;
  handleDrawerOpen?: any;
  setModalOpenSchool?: any;
  values: any;
  handleBlur: any;
  errors: any;
  touched: any;
  setFieldValue: any;
  handleChange: any;
  courseNameOptions: any;
  ciNameOptions: any;
  batchNameOptions: any;
  levelStatusOptions: any;
  levelAdmissionFetched: any;
  levelOfAdmissionChanged: any;
}

const CourseBatchInformation = (props: CourseBatchInfoProps) => {
  const {
    values,
    handleChange,
    handleBlur,
    errors,
    touched,
    levelOfAdmissionChanged,
  } = props;
  const { setFieldValue, courseNameOptions } = props;
  const [ciNameOptions, setCiNameOptions] = useState<any>(props.ciNameOptions);
  const [showHideAddCiWindow, setShowHideAddCiWindow] =
    useState<boolean>(false);
  const { batchNameOptions, levelStatusOptions, levelAdmissionFetched } = props;

  const dateFormat = process.env.REACT_APP_DEFAULT_DATE_FORMAT;
  const { t } = useTranslation();
  const ref = useRef(true);
  const dispatch = useAppDispatch();
  const centerTypeId = LocalStorage.get("centerTypeId");

  const [levelOfAdmission, setLevelOfAdmission] = useState<any>([]);
  const [levelOfAdmissionList, setLevelOfAdmissionList] = useState<any>([]);
  const [levelDuration, setLevelDuration] = useState(values.levelDuration || 0);
  const [batchOptions, setBatchOptions] = useState<any>([]);
  const [spinner, setSpinner] = useState(false);

  const handleCourseChange = (value: number, setFieldValue: any) => {
    setFieldValue("courseId", value);
    setFieldValue("levelOfAdmissionId", undefined);
    setFieldValue("courseInstructor", undefined);
    setFieldValue("courseInstructorId", undefined);
    setFieldValue("batchId", undefined);

    getLevelOfAdmissionListByCourseId(value);
  };

  useEffect(() => {
    if (ref.current) {
      ref.current = false;
      getLevelOfAdmissionListByCourseId(values.courseId);
      if (values.courseInstructorId)
        getBatchDropdownByInstructorId({
          apiAction: "batchDropdownByInstructorId",
          courseId: values.courseId,
          instructorId: values.courseInstructorId,
        });
    }
  });
  const ciCreated = (data: any) => {
    if (data.status === 200) {
      getCIList({ apiAction: "list" }).then((ciData: any) => {
        handleCourseInstructorChange(ciData[ciData.length - 1]);
      });
    }
    setShowHideAddCiWindow(false);
  };

  const getCIList = async (values: any) => {
    setSpinner(true);
    let ciData: any;
    await dispatch(courseInstructorAction(values))
      .then((result: any) => {
        if (result?.payload?.status === 200) {
          ciData = CommonUtil.formateDropdownList(
            result?.payload?.data.data,
            "courseInstructorName"
          );

          setCiNameOptions(ciData);
        } else {
          Toaster.error(undefined, result.payload);
        }
      })
      .catch((err: any) => {
        console.log(err); //This console for debug the app if any error occurred in DEV
      })
      .finally(() => {
        setSpinner(false);
      });
    return ciData;
  };
  //Get Level of admission  List
  const getLevelOfAdmissionListByCourseId = (courseId: any) => {
    setSpinner(true);
    dispatch(CommonService({ apiAction: "CourseLevel", courseId: courseId }))
      .then((result: any) => {
        if (result?.payload?.status === 200) {
          const levelsOfAdmission = result?.payload?.data.data;
          if (values.registrationType === "New") {
            const entryLevels = levelsOfAdmission.filter((level: any) => {
              return level.entryLevel === "Yes";
            });
            setLevelOfAdmissionList(entryLevels);
            setLevelOfAdmission(
              CommonUtil.formateDropdownList(entryLevels, "levelName")
            );
          } else {
            setLevelOfAdmissionList(levelsOfAdmission);
            setLevelOfAdmission(
              CommonUtil.formateDropdownList(levelsOfAdmission, "levelName")
            );
          }
        } else {
          Toaster.error(undefined, result.payload);
        }
      })
      .catch((err: any) => {
        console.log(err); //This console for debug the app if any error occurred in DEV
      })
      .finally(() => {
        setSpinner(false);
      });
  };

  // Get Level of admission  details
  const getLevelAdmissionDetails = (apiValues: any) => {
    dispatch(itemMasterService(apiValues))
      .then((result: any) => {
        if (result?.payload?.status === 200) {
          levelAdmissionFetched(result?.payload);
        } else {
          Toaster.error(undefined, result.payload);
        }
      })
      .catch((err: any) => {
        console.log(err); //This console for debug the app if any error occurred in DEV
      });
  };

  const handleLevelStartDt = (e: any) => {
    setFieldValue("levelStartDate", e);
    const fourMonthsAgo = new Date(e?.$d);
    fourMonthsAgo.setMonth(e?.$d.getMonth() + levelDuration);
    setFieldValue("levelEndDate", moment(fourMonthsAgo).format(dateFormat));
  };

  const levelOfAdmissionHander = (e: any) => {
    setFieldValue("levelOfAdmissionId", e.target.value);
    getLevelAdmissionDetails({
      apiAction: "LevelDetails",
      courseLevelId: e.target.value,
      courseId: values.courseId,
      centerTypeId,
    });
    setLevelDuration(
      levelOfAdmissionList?.find((item: any) => item.id === e.target.value)
        .levelDuration
    );
    setFieldValue(
      "levelDuration",
      levelOfAdmissionList?.find((item: any) => item.id === e.target.value)
        .levelDuration
    );
    if (values.levelStartDate) {
      const fourMonthsAgo = new Date(values.levelStartDate?.$d);
      fourMonthsAgo.setMonth(
        values.levelStartDate?.$d.getMonth() +
          levelOfAdmissionList?.find((item: any) => item.id === e.target.value)
            .levelDuration
      );
      setFieldValue("levelEndDate", moment(fourMonthsAgo).format(dateFormat));
      levelOfAdmissionChanged();
    }
    if (e.target.value === 1) setFieldValue("brandPromiseScore", "");
  };

  // Get Batch Dropdown By Instructor Id
  const getBatchDropdownByInstructorId = (apiValues: any) => {
    dispatch(studentMasterService(apiValues))
      .then((result: any) => {
        if (result?.payload?.status === 200) {
          setBatchOptions(
            CommonUtil.formateDropdownListWithAllData(
              result?.payload?.data?.data?.filter(
                (batch: any) => batch.active === "Yes"
              ),
              "batchName"
            )
          );
        } else {
          Toaster.error(undefined, result.payload);
        }
      })
      .catch((err: any) => {
        console.log(err); //This console for debug the app if any error occurred in DEV
      });
  };

  const handleCourseInstructorChange = (value: any) => {
    setFieldValue("courseInstructor", value);
    setFieldValue("courseInstructorId", value.value);

    getBatchDropdownByInstructorId({
      apiAction: "batchDropdownByInstructorId",
      instructorId: value.value,
      courseId: values.courseId,
    });
  };

  return (
    <Grid className="sidenav-container">
      <Box style={{ width: "100%" }}>
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <div>
              {/* <div className="autocomplete-form">
                <Label required title={t("selectCourseName")} />
                <SelectField
                  name="courseId"
                  value={values.courseId}
                  onChange={(e: any) => {
                    handleCourseChange(e.target.value, setFieldValue);
                    setBatchOptions([]);
                  }}
                  options={courseNameOptions}
                />
              </div> */}

              <div className="">
                <Label required title={t("registeredDate")} />

                <SimpleDate
                  className="textFiled"
                  name="registeredDate"
                  value={values.registeredDate}
                  onChange={(e: any) => {
                    setFieldValue("registeredDate", e);
                    setFieldValue("levelStartDate", "");
                  }}
                  minDate={dayjs().subtract(1, "month").startOf("month")}
                  maxDate={dayjs().endOf("month")}
                  onBlur={handleBlur}
                  format={countryWiseDateFormate()}
                  helperText={<ErrorMessage name="registeredDate" />}
                  error={errors.registeredDate && touched.registeredDate}
                />
              </div>
              <div className="form-ele-gap">
                <Label required title={t("SelectLevelOfAdmission")} />
                <SelectField
                  name="levelOfAdmissionId"
                  value={values.levelOfAdmissionId || t("select")}
                  onChange={(e: any) => levelOfAdmissionHander(e)}
                  onBlur={handleBlur}
                  inputProps={{ "aria-label": "Without label" }}
                  options={levelOfAdmission}
                  helperText={<ErrorMessage name="levelOfAdmissionId" />}
                  error={
                    errors.levelOfAdmissionId && touched.levelOfAdmissionId
                  }
                />
              </div>
              <div style={{ paddingTop: "7px" }}>
                {Number(LoginUserDetails.getUserDetails().productId === 1) ? (
                  <div className="inherit-number-field">
                    <Label title={t("BrandPromiseScore")} />
                    <Field
                      className="textFiled"
                      disabled={values.levelOfAdmissionId === 1}
                      name="brandPromiseScore"
                      placeholder={t("enterHere")}
                      value={values?.brandPromiseScore}
                      type="number"
                      onInput={(e: any) => CommonUtil.checkLengthHandler(e, 3)}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      onKeyUp={(e: any) => {
                        if (Number(e.target.value) > 100)
                          setFieldValue("brandPromiseScore", 100);
                      }}
                      helperText={<ErrorMessage name="brandPromiseScore" />}
                      error={
                        errors.brandPromiseScore && touched.brandPromiseScore
                      }
                    />
                  </div>
                ) : (
                  <></>
                )}
              </div>
              <div className="padding-top-5">
                <div className="form-ele-gap">
                  <Label required title={t("ci")} />
                  <EditableSelectField
                    name="courseInstructor"
                    value={values.courseInstructor || t("select")}
                    onChange={(value: any) => {
                      handleCourseInstructorChange(value);
                    }}
                    onBlur={handleBlur}
                    inputProps={{ "aria-label": "Without label" }}
                    options={ciNameOptions?.filter(
                        (ci: any) => ci.active === "Yes"
                      )}
                    helperText={<ErrorMessage name="courseInstructorId" />}
                    error={
                      errors.courseInstructorId && touched.courseInstructorId
                    }
                  />
                  <div className="full center-end margin-up-10">
                    <AddCircle
                      className={`color-sec margin-x-10`}
                      style={{ fontSize: "20px" }}
                    />
                    <p
                      className={"link-black font-14"}
                      onClick={() =>
                        setShowHideAddCiWindow(!showHideAddCiWindow)
                      }
                    >
                      {t("addCi")}
                    </p>
                  </div>
                  {showHideAddCiWindow && <AddCi ciCreated={ciCreated}></AddCi>}
                </div>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <div>
              <div className="autocomplete-form">
                <Label title={t("batchName")} />
                <SelectField
                  name="batchId"
                  value={values.batchId || t("select")}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  inputProps={{ "aria-label": "Without label" }}
                  options={batchOptions}
                  helperText={<ErrorMessage name="batchId" />}
                  error={errors.batchId && touched.batchId}
                />
              </div>
              <div className="form-ele-gap">
                <Label required title={t("levelStartDate")} />
                <SimpleDate
                  className="textFiled"
                  name="levelStartDate"
                  value={values.levelStartDate}
                  onChange={(e: any) => handleLevelStartDt(e)}
                  format={countryWiseDateFormate()}
                  onBlur={handleBlur}
                  minDate={values.registeredDate}
                  helperText={<ErrorMessage name="levelStartDate" />}
                  error={errors.levelStartDate && touched.levelStartDate}
                />
              </div>
              <div className="form-ele-gap">
                <Label title={t("levelEndDate")} />
                <Field
                  disabled
                  placeholder={t("filledAutomatically")}
                  className="textFiled"
                  style={{ marginBottom: "0px" }}
                  name="levelEndDate"
                  
                  value={dayjs(DateTimeUtil.format(values?.levelEndDate, dateFormat, true)).format(countryWiseDateFormate())}
                  onChange={handleChange}
                  format={countryWiseDateFormate()}
                  onBlur={handleBlur}
                  helperText={<ErrorMessage name="levelEndDate" />}
                  error={errors.levelEndDate && touched.levelEndDate}
                />
              </div>

              <div className="form-ele-gap">
                <Label title={t("levelStatus")} />
                <SelectField
                  name="levelStatusId"
                  disabled
                  value={values.levelStatusId}
                  onChange={handleChange}
                  displayEmpty
                  inputProps={{ "aria-label": "Without label" }}
                  options={levelStatusOptions}
                />
              </div>
            </div>
          </Grid>
        </Grid>
      </Box>
      <GlobalLoader loading={spinner} />
    </Grid>
  );
};

export default CourseBatchInformation;
